document.addEventListener("DOMContentLoaded", function () {
  function featureAccordion() {
    const accordionContainer = document.querySelector(".accordion-feature");
    if (!accordionContainer) return;

    const accordionItems =
      accordionContainer.querySelectorAll(".accordion-item");
    const flexContainer = accordionContainer.closest(".flex");
    if (!flexContainer) return;
    const imageContainer = flexContainer.querySelector(
      ".relative.aspect-square"
    );
    if (!imageContainer) return;
    const imageWrappers = imageContainer.querySelectorAll("div[data-index]");

    // ----------------------------
    // INITIAL STATE SETUP
    // ----------------------------
    // Hide all accordion contents, mark buttons as closed,
    // and set plus icon rotation to 0.
    accordionItems.forEach((item) => {
      const button = item.querySelector(".accordion-title");
      const content = item.querySelector(".accordion-content");
      const plusIcon = item.querySelector(".plus-icon");
      button.setAttribute("aria-expanded", "false");
      content.style.display = "none";
      gsap.set(content, { height: 0, opacity: 0 });
      if (plusIcon) {
        gsap.set(plusIcon, { rotation: 0 });
      }
    });

    // Show the first image by default based on the first accordion button's aria-controls value.
    if (accordionItems.length > 0) {
      const firstButton = accordionItems[0].querySelector(".accordion-title");
      const firstControl = firstButton.getAttribute("aria-controls");
      imageWrappers.forEach((wrapper) => {
        if (wrapper.getAttribute("data-index") === firstControl) {
          wrapper.style.display = "block";
          gsap.set(wrapper, {
            opacity: 1,
            clipPath: "polygon(0 0%, 100% 0%, 100% 100%, 0 100%)",
          });
        } else {
          wrapper.style.display = "none";
          gsap.set(wrapper, {
            opacity: 0,
            clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)",
          });
        }
      });
    }

    // ----------------------------
    // ACCORDION CLICK HANDLER
    // ----------------------------
    accordionItems.forEach((item) => {
      const button = item.querySelector(".accordion-title");
      const plusIcon = item.querySelector(".plus-icon");

      button.addEventListener("click", function () {
        // Capture whether this item is currently open before closing all.
        const wasOpen = item.classList.contains("open");

        // Determine the target image using the button's aria-controls value.
        const control = button.getAttribute("aria-controls");
        const targetImage = imageContainer.querySelector(
          `div[data-index="${control}"]`
        );

        // Close all accordion items and reset their plus icons.
        accordionItems.forEach((itm) => {
          const btn = itm.querySelector(".accordion-title");
          const cnt = itm.querySelector(".accordion-content");
          const icon = itm.querySelector(".plus-icon");
          btn.setAttribute("aria-expanded", "false");
          if (itm.classList.contains("open")) {
            gsap.to(cnt, {
              height: 0,
              opacity: 0,
              duration: 0.3,
              ease: "power1.inOut",
              onComplete: () => {
                cnt.style.display = "none";
              },
            });
          } else {
            cnt.style.display = "none";
            gsap.set(cnt, { height: 0, opacity: 0 });
          }
          itm.classList.remove("open");

          // Reset the plus icon rotation.
          if (icon) {
            gsap.to(icon, { rotation: 0, duration: 0.3, ease: "power1.inOut" });
          }
        });

        // Animate out all images except the target image.
        imageWrappers.forEach((wrapper) => {
          if (wrapper !== targetImage) {
            gsap.to(wrapper, {
              clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)",
              duration: 0.5,
              ease: "power1.inOut",
              onComplete: function () {
                wrapper.style.display = "none";
                gsap.set(wrapper, { opacity: 0 });
              },
            });
          }
        });

        // Only open the clicked accordion item if it wasn't already open.
        if (!wasOpen) {
          item.classList.add("open");
          button.setAttribute("aria-expanded", "true");
          const content = item.querySelector(".accordion-content");
          content.style.display = "block";
          // Animate in the content (slide down & fade in).
          gsap.fromTo(
            content,
            { height: 0, opacity: 0 },
            {
              height: "auto",
              opacity: 1,
              duration: 0.5,
              ease: "power4.inOut",
            }
          );

          // Animate in the target image.
          if (targetImage) {
            targetImage.style.display = "block";
            gsap.set(targetImage, {
              opacity: 1,
              clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)",
            });
            gsap.to(targetImage, {
              clipPath: "polygon(0 0%, 100% 0%, 100% 100%, 0 100%)",
              duration: 0.5,
              ease: "power4.inOut",
            });
          }

          // Rotate the plus icon 45deg.
          if (plusIcon) {
            gsap.to(plusIcon, {
              rotation: 45,
              duration: 0.5,
              ease: "power4.inOut",
            });
          }
        }
      });
    });
  }

  featureAccordion();
});